module.exports = __webpack_public_path__ + "img/loisir6.99046cdb.png";